import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { IRegistrationData } from '../types';
import { USER_REGISTRATION_API } from '../userRegistrationAPIClient';

/**
 * This is to track the login mutation keys in react query cache.
 */
const MUT_REGISTER_USER = 'user-register-mutation-key';

interface IUseRegistrationOptions {
  onErrorCallback: (err: IApiError) => void;
  onSuccessCallback: (registerUserData: IRegistrationData) => void;
}

/**
 * This performs a registration request and retrieves the user info and token.
 * Provides data fetching states and a callback to be used in the redirection later.
 */
export const useRegistrationMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: IUseRegistrationOptions) => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [MUT_REGISTER_USER],
    networkMode: 'always',
    retry: false,
    mutationFn: USER_REGISTRATION_API.registerUser,
    onSuccess: onSuccessCallback,
    onError: onErrorCallback,
  });

  return {
    error,
    isPending,
    submitRegistration: mutate,
  };
};
